export default __webpack_public_path__ + "static/media/math_test_mock_bg.3a7c1317.png";